import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "comments-row" };
const _hoisted_2 = { class: "td__type ta-c" };
const _hoisted_3 = { class: "ta-s" };
const _hoisted_4 = { class: "td__createdAt ta-c" };
import { computed } from 'vue';
import dateFormatType from '@/constants/dateFormatType';
import { isTodayTextColor, formatDate, } from '@/utils';
import { enumProcessingType, enumProcessing, } from '@/constants/memberCompanyInquiry/memberCompanyInquiryTableHeader';
export default /*@__PURE__*/ _defineComponent({
    __name: 'CommentRow',
    props: {
        item: {}
    },
    setup(__props) {
        const props = __props;
        /**
         * v-chip(typeClass)의 클래스 설정
         */
        const typeClass = computed(() => {
            const cssClass = {};
            switch (props.item.commentProcessingType) {
                /** 접수 */
                case enumProcessing.RECEIVED:
                    cssClass['brg-color-blue-700'] = true;
                    break;
                /** 진행 */
                case enumProcessing.IN_PROGRESS:
                    cssClass['brg-color-orange-700'] = true;
                    break;
                /** 완료 */
                case enumProcessing.DONE:
                    cssClass['brg-color-green-700'] = true;
                    break;
                /** 반려 */
                case enumProcessing.REJECTED:
                    cssClass['brg-color-red-700'] = true;
                    break;
                /** 기등록벤 */
                case enumProcessing.ALREADY_ACCEPTED_VAN:
                    cssClass['brg-color-purple-700'] = true;
                    break;
                /** 제외 */
                case enumProcessing.NO:
                    cssClass['brg-color-grey-700'] = true;
                    break;
                default:
                    cssClass['brg-color-black'] = true;
            }
            return cssClass;
        });
        return (_ctx, _cache) => {
            const _component_v_chip = _resolveComponent("v-chip");
            return (_openBlock(), _createElementBlock("tr", _hoisted_1, [
                _createElementVNode("td", _hoisted_2, [
                    _createElementVNode("span", null, [
                        _createVNode(_component_v_chip, {
                            size: "small",
                            class: _normalizeClass(typeClass.value)
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(enumProcessingType)[props.item.commentProcessingType]), 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["class"])
                    ])
                ]),
                _createElementVNode("td", _hoisted_3, _toDisplayString(props.item.commentContent), 1 /* TEXT */),
                _createElementVNode("td", _hoisted_4, [
                    _createElementVNode("span", {
                        class: _normalizeClass(_unref(isTodayTextColor)(props.item.createdAt))
                    }, _toDisplayString(_unref(formatDate)(props.item.commentCreatedAt, _unref(dateFormatType).FULL_DATE)), 3 /* TEXT, CLASS */)
                ])
            ]));
        };
    }
});
